import { Component, OnInit, signal } from '@angular/core';
import { HELP_MULTI_TRAIT_QUERY } from '../app.constants';
import { HelpService } from '../shared/service/help.service';
import { AlertService } from '../shared/alert/alert.service';
import { ParamContext } from '../shared/service/param.context';
import { JhiLanguageService } from '../shared/core-utils';
import { MultiTraitQueryContext } from './multi-trait-query-context';
import { TraitFilterContext } from './setup-trait-filter-step-panel/trait-filter-context';
import { Router } from '@angular/router';

@Component({
    selector: 'jhi-multi-trait-query',
    styleUrl: './multi-trait-query.component.css',
    templateUrl: './multi-trait-query.component.html'
})
export class MultiTraitQueryComponent implements OnInit {

    helpLink: string;
    step = signal(0);

    constructor(private jhiLanguageService: JhiLanguageService,
                private alertService: AlertService,
                private paramContext: ParamContext,
                private queryContext: MultiTraitQueryContext,
                private traitFilterContext: TraitFilterContext,
                private router: Router,
                private helpService: HelpService) {
        this.paramContext.readParams();
    }

    ngOnInit(): void {
        if (!this.helpLink || !this.helpLink.length) {
            this.helpService.getHelpLink(HELP_MULTI_TRAIT_QUERY).toPromise().then((response) => {
                this.helpLink = response.body;
            });
        }
    }

    setStep(index: number) {
        this.step.set(index);
    }

    nextStep() {
        this.step.update(i => i + 1);
    }

    prevStep() {
        this.step.update(i => i - 1);
    }

    isStepEnabled(index: number): boolean {
        let isStepEnabled = false;
        if (index === 2) {
            isStepEnabled = this.queryContext.hasSelectTraits();
        }
        if (index === 3) {
            isStepEnabled = this.queryContext.hasSelectTraits() &&
                this.queryContext.hasEnvironmentSelected();
        } else if (index === 4) {
            isStepEnabled = this.queryContext.hasSelectTraits() &&
                this.queryContext.hasEnvironmentSelected() &&
                !this.traitFilterContext.areAllTraitsDropped();
        }
        return isStepEnabled;
    }

}
